import React from "react"
import { Pane } from "components/ui"
import { string, number, bool } from "prop-types"
import { HelperShelfTrigger } from "components/helper_shelf"
import { pluralize } from "utils/helpers"

const Title = ({ group, isFormQuestion, questionsLength }) => {
  return (
    <Pane.Title className="pane__title--matchTable">
      <>
        {isFormQuestion
          ? "Attendee information form"
          : pluralize("question", "questions", questionsLength)}

        {isFormQuestion && (
          <span className="ml-1">
            <HelperShelfTrigger id={`questions-heading-${group}`} />
          </span>
        )}
      </>
    </Pane.Title>
  )
}

Title.propTypes = {
  group: string,
  isFormQuestion: bool,
  questionsLength: number
}

export default Title
